import { render, staticRenderFns } from "./OverviewTableUserAccessManagement.vue?vue&type=template&id=2d481fdc&"
import script from "./OverviewTableUserAccessManagement.vue?vue&type=script&lang=ts&"
export * from "./OverviewTableUserAccessManagement.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewTableUserAccessManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports